import axios from "../axios";
const endPoint = `/system`

export const getFees = async () => {
    return await axios.get(`${endPoint}`)
}


export const getShippingExpenses = async () => {
    try {
      const response = await axios.get(`${endPoint}/getShippingExpenses`);
      return response;
    } catch (error) {
      console.error('Error fetching shipping expenses', error);
      return { amount: 0 };
    }
  };
